// add gates here
import { gate } from 'hub-http/gates';
export const LIST_MEMBERSHIP_TABLE_MIGRATION = gate('CRM:Records:ListMembershipMigration');
export const SCROLLABLE_TABS = gate('CRM:Records:ScrollableTabs');
export const DEPRECATE_LEGACY_TIMELINE = gate('CRM:Events:DeprecateLegacyTimeline');
export const ASSOCIATION_CARD_REDESIGN = gate('CRM:Record:AssociationCardRedesign');
export const CATCHUP_CARDS = gate('CRM:Cards:CatchupTab');
export const CATCHUP_CARDS_M2 = gate('CRM:Cards:CatchupTabM2');
export const CATCHUP_CARDS_M3 = gate('CRM:Cards:CatchupTabM3');
export const HIGHLIGHT_CARD = gate('CRM:Records:ObjectHighlightCard');
export const WORKFLOWS_MANUAL_ENROLL_TEAM_OWNED = gate('Permissions:WorkflowsManualEnrollTeamOwned');
export const CONTRACTS_M2_CHANGES_WITHOUT_PRORATION = gate('Commerce:Contracts:M2:ChangesWithoutProration');